import * as client from "_graphql-types";
import * as types from "./types";

type Sdk = ReturnType<typeof client.getSdk>;

/*********************************************************************/
// Data Provider Functions
/*********************************************************************/

/*********************************************************************/
async function getList(sdk: Sdk, params: types.GetListParams<client.PeInctFeeCalcEnumSortEnum>) {
  const {
    pagination: { page, perPage },
    sort: { field, order }
  } = params;

  const {
    peInctFeeCalcEnumList: { items: data, total }
  } = await sdk.getListPeInctFeeCalcEnum({
    page: {
      offset: (page - 1) * perPage,
      limit: perPage
    },
    sort: [{ field, order }]
  });

  return {
    data,
    total,
  };
}

/*********************************************************************/
async function getOne(sdk: Sdk, params: types.GetOneParams) {
  const id = Number(params.id);
  const { peInctFeeCalcEnum: data } = await sdk.getOnePeInctFeeCalcEnum({
    id
  });
  return {
    data,
  };
}

/*********************************************************************/
async function getMany(sdk: Sdk, params: types.GetManyParams) {
  const ids = params.ids.map(Number);

  const {
    peInctFeeCalcEnumMany: data
  } = await sdk.getManyPeInctFeeCalcEnum({
    ids
  });

  return {
    data,
  };
}


/*********************************************************************/
export const peInctFeeCalcEnum = types.dataProvider({
  getList,
  getOne,
  getMany
});